import { Pane, Spinner, Text, Button } from 'evergreen-ui';

export default function TurniPdfPreviewArea({ pdfUrl, loading, isMobile, onDownload }) {
  return (
    <div style={{ flex: 1, position: 'relative', background: isMobile ? '#f9f9fb' : '#555', overflow: 'hidden' }}>
      {loading && (
        <Pane position="absolute" top={0} left={0} right={0} bottom={0} display="flex" alignItems="center" justifyContent="center" background="rgba(255,255,255,0.88)" zIndex={1}>
          <Spinner />
          <Text marginLeft={12} color="muted">Generazione PDF in corso...</Text>
        </Pane>
      )}
      {isMobile ? (
        !loading && (
          <Pane display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%" gap={16} padding={24}>
            <Text size={400} textAlign="center">L'anteprima non è disponibile su dispositivi mobili.</Text>
            <Text size={300} color="muted" textAlign="center">Usa il bottone "Scarica PDF" per aprire il documento.</Text>
            <Button appearance="primary" size="large" onClick={onDownload}>Scarica PDF</Button>
          </Pane>
        )
      ) : (
        pdfUrl && !loading && (
          <iframe src={pdfUrl} title="Anteprima PDF turni" style={{ width: '100%', height: '100%', border: 'none', display: 'block' }} />
        )
      )}
    </div>
  );
}
